// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".upsert-schedule-fields .briq-form-element {\n  margin-bottom: 24px;\n}\n#app {\n  background: transparent;\n}\n.start-end-time-validation-message {\n  margin-bottom: 24px;\n  margin-top: -18px;\n}\n", ""]);
// Exports
module.exports = exports;
